// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customers__reviews[data-v-51c8897c]{display:grid;grid-template-columns:repeat(auto-fit,max-content);grid-gap:4rem;gap:4rem}.customers__text[data-v-51c8897c]:not(:first-child){margin-bottom:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
